'use strict';

// //////////////////////////////////////////////////////////
// This helper is already imported in our common bundle !
// //////////////////////////////////////////////////////////

if (typeof Element.prototype.fadeIn !== 'function') {
    Element.prototype.fadeIn = function fadeIn(display = 'inline') {
        const element = this;
        if (element.style.opacity >= 1) {
            return;
        }

        element.style.opacity = 0;
        element.style.display = display;

        (function fade() {
            let val = parseFloat(element.style.opacity);
            if (!((val += 0.1) > 1)) {
                element.style.opacity = val;
                // Originally, it was stored in Hop.window
                // But Hop.window = window
                // ...so....
                window.requestAnimationFrame(fade);
            }
        })();
    };
}

if (typeof Element.prototype.fadeOut !== 'function') {
    Element.prototype.fadeOut = function fadeOut() {
        const element = this;
        if (element.style.opacity <= 0) {
            return;
        }

        element.style.opacity = 1;

        (function fade() {
            (element.style.opacity -= 0.1) < 0 ? (element.style.display = 'none') : window.requestAnimationFrame(fade);
        })();
    };
}
